import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const restoreProviderOrderTrackingConfig = () => ({
  'type': ActionTypes.RESTORE_PROVIDER_ORDERS_TRACKING_CONFIG,
});

export const updateValueForOrderTrackingConfig = ({section, step, field, value}) => ({
  'type': ActionTypes.UPDATE_PROVIDER_ORDER_TRACKING_CONFIG_VALUE,
  'payload': {section, step, field, value},
});

export const getProviderOrderTrackingConfig = (provider, orderType) => apiActionCreator({
  'endpoint': `/orders/dealers/tracking-configuration${getUrlParameters({provider, orderType})}`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_PROVIDER_ORDERS_TRACKING_CONFIG_REQUEST,
    [
      {'type': ActionTypes.GET_PROVIDER_ORDERS_TRACKING_CONFIG_SUCCESS},
    ],
    [
      ActionTypes.GET_PROVIDER_ORDERS_TRACKING_CONFIG_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const saveProviderOrderTrackingConfig = (data) => apiActionCreator({
  'endpoint': '/orders/dealers/tracking-configuration',
  'authenticated': true,
  'types': [
    ActionTypes.SAVE_PROVIDER_ORDERS_TRACKING_CONFIG_REQUEST,
    [
      {'type': ActionTypes.SAVE_PROVIDER_ORDERS_TRACKING_CONFIG_SUCCESS},
      MessageActions.addMessageBoxInfo('Configuración guardada satisfactoriamente.'),
    ],
    [
      ActionTypes.SAVE_PROVIDER_ORDERS_TRACKING_CONFIG_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': {data},
});
